(() => {
  const storageKey = 'hexo-wishlist';
  const validUrl = value => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin && /\/products\/[^/]+/.test(url.pathname); } catch { return false; }
  };
  const read = () => {
    try { const list = JSON.parse(localStorage.getItem(storageKey) || '[]'); return Array.isArray(list) ? list.filter(item => item && validUrl(item.url)).slice(0,500) : []; } catch { return []; }
  };
  const labels = () => document.getElementById('hexo-wishlist')?.dataset || {};
  const syncButtons = () => {
    const list = read();
    document.querySelectorAll('.hx-wish').forEach(button => {
      const pressed = list.some(item => item.url === button.dataset.productUrl);
      button.setAttribute('aria-pressed', String(pressed));
      button.textContent = pressed ? '♥' : '♡';
    });
    document.querySelectorAll('[data-hx-wishlist-count]').forEach(count => {
      count.hidden = !list.length;
      if (count.textContent !== String(list.length)) count.textContent = String(list.length);
    });
  };
  const renderWishlist = () => {
    const list = read();
    document.querySelectorAll('[data-hexo-wishlist]').forEach(root => {
      root.replaceChildren();
      if (!list.length) { const p = document.createElement('p'); p.textContent = labels().emptyLabel || ''; root.append(p); }
      list.forEach(item => {
        const row = document.createElement('article'); row.className = 'hx-wishlist-row';
        const picture = document.createElement('a'); picture.href = item.url; picture.tabIndex = -1; picture.setAttribute('aria-hidden','true');
        if (typeof item.image === 'string' && /^(https:|\/\/)/.test(item.image)) {
          const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.loading = 'lazy'; picture.append(img);
        }
        const link = document.createElement('a'); link.href = item.url; link.textContent = String(item.title || '');
        const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.dataset.hxRemove = item.url; remove.setAttribute('aria-label', labels().removeLabel || '');
        row.append(picture,link,remove); root.append(row);
      });
    });
    syncButtons();
  };
  const write = list => {
    try { localStorage.setItem(storageKey, JSON.stringify(list)); document.dispatchEvent(new Event('hexo:wishlist')); } catch { /* Storage can be unavailable in private browsing. */ }
  };
  const initialized = new WeakSet();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const motionReduced = () => reducedMotion.matches || document.documentElement.hasAttribute('data-hx-reduce-motion');
  const pauseMotion = () => {
    if (motionReduced()) document.querySelectorAll('.hx-hero video').forEach(video => video.pause());
  };
  reducedMotion.addEventListener('change', pauseMotion);
  document.addEventListener('hexo:accessibility-change', pauseMotion);
  const init = () => {
    document.querySelectorAll('.hx-hero').forEach(hero => {
      if (initialized.has(hero)) return;
      initialized.add(hero);
      const video=hero.querySelector('video'), play=hero.querySelector('.hx-video-toggle'), audio=hero.querySelector('.hx-video-audio');
      if (!video || !play) return;
      const update = () => {
        hero.dataset.motionPaused = String(video.paused);
        play.textContent = video.paused ? '▷' : 'Ⅱ';
        play.setAttribute('aria-label', video.paused ? play.dataset.playLabel : play.dataset.pauseLabel);
        if (audio) { audio.textContent = video.muted ? audio.dataset.unmuteLabel : audio.dataset.muteLabel; audio.setAttribute('aria-label',audio.textContent); audio.setAttribute('aria-pressed',String(!video.muted)); }
      };
      if (motionReduced()) video.pause();
      play.addEventListener('click', () => video.paused ? video.play().catch(update) : video.pause());
      audio?.addEventListener('click', () => { video.muted = !video.muted; update(); });
      ['play','pause','volumechange'].forEach(event => video.addEventListener(event,update));
      update();
    });
    document.querySelectorAll('.hx-menu,.hx-mobile-menu').forEach(menu => {
      if(initialized.has(menu)) return;
      initialized.add(menu);
      menu.addEventListener('toggle',()=>{if(menu.open) document.querySelectorAll('.hx-menu[open],.hx-mobile-menu[open]').forEach(other=>{if(other!==menu) other.open=false;});});
      let focusCheck;
      menu.addEventListener('focusin',()=>cancelAnimationFrame(focusCheck));
      menu.addEventListener('focusout',event=>{
        cancelAnimationFrame(focusCheck);
        if(event.relatedTarget && menu.contains(event.relatedTarget)) return;
        // Wait for the browser's complete focus transfer before dismissing the menu.
        focusCheck=requestAnimationFrame(()=>{
          if(menu.contains(document.activeElement)) return;
          if(menu.matches('.hx-menu') && menu.matches(':hover')) return;
          menu.open=false;
        });
      });
      if(menu.matches('.hx-menu')){
        let closeTimer;
        menu.addEventListener('pointerenter',()=>{clearTimeout(closeTimer);if(matchMedia('(hover:hover) and (min-width:1024px)').matches)menu.open=true;});
        menu.addEventListener('pointerleave',()=>{closeTimer=setTimeout(()=>{if(!menu.contains(document.activeElement))menu.open=false;},180);});
      }
    });
    syncButtons();
  };
  document.addEventListener('click',event => {
    const desktopSummary=event.target.closest('.hx-menu>summary');
    if(desktopSummary && event.detail>0 && matchMedia('(hover:hover) and (min-width:1024px)').matches && desktopSummary.parentElement.open)event.preventDefault();
    const wish = event.target.closest('.hx-wish');
    if (wish && validUrl(wish.dataset.productUrl)) {
      event.preventDefault(); event.stopPropagation();
      const list=read(),url=wish.dataset.productUrl;
      write(list.some(item=>item.url===url) ? list.filter(item=>item.url!==url) : [...list,{url,title:wish.dataset.productTitle,image:wish.dataset.productImage}]);
    }
    const remove=event.target.closest('[data-hx-remove]');
    if(remove) { write(read().filter(item=>item.url!==remove.dataset.hxRemove)); document.querySelector('#hexo-wishlist [data-hx-close]')?.focus(); }
    const back=event.target.closest('[data-hx-back]');
    if(back){const level=back.closest('details');level.open=false;level.querySelector('summary')?.focus();}
    document.querySelectorAll('.hx-menu[open],.hx-mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target)) menu.open=false;});
  });
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    const menu=event.target.closest('details[open]');
    if(menu?.matches('.hx-menu,.hx-mobile-menu,.hx-mobile-level')){event.preventDefault();event.stopPropagation();menu.open=false;menu.querySelector('summary')?.focus();}
  });
  document.addEventListener('hexo:wishlist',renderWishlist);
  window.addEventListener('storage',event=>{if(event.key===storageKey)renderWishlist();});
  document.addEventListener('shopify:section:load',init);
  const observer = new MutationObserver(records => { if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1 && (node.matches?.('product-card,.hx-wish')||node.querySelector?.('.hx-wish'))))) syncButtons(); });
  observer.observe(document.body,{childList:true,subtree:true});
  init();renderWishlist();
})();


